import dayjs, { ManipulateType, OpUnitType, QUnitType } from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/ky'
import 'dayjs/locale/ru'
import updateLocale from 'dayjs/plugin/updateLocale'

import i18n from 'app/i18/i18'

import { ageRanges } from 'entities/ticket/ui/purchase-from/model.ts'

import { TYPE_AGE } from 'shared/constants'

import { DATE_FORMAT_LIST, monthsShort } from '../constants/dateFormatList'

dayjs.locale(i18n.language)
i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng)
})

interface AddDateManipulate {
  date?: Date | string
  count: number
  type: ManipulateType
}

interface DateDifference {
  dateEnd?: Date | string
  type: QUnitType | OpUnitType
  dateStart?: Date | string
  isFloat?: boolean
}

interface EndDate {
  date: Date | string
  type: OpUnitType
}

dayjs.extend(updateLocale)
dayjs.updateLocale('ru', { monthsShort })

export const dateFormat = (date?: Date | string, formatDate?: string) => {
  if (String(date).length === 0) return ''

  const formattedDate = dayjs(date).format(
    formatDate || DATE_FORMAT_LIST.DATE_MONTH,
  )

  return formattedDate.replace(/\.$/, '')
}

export const dateFormatCalendar = (date: string, formatDate?: string) => {
  if (date?.length) return ''

  return dayjs(date).format(formatDate || DATE_FORMAT_LIST.DATE_MONTH)
}

export const prepareDateFormat = (date?: string) => {
  if (!date) return ''

  return date.split('-').reverse().join('.')
}

export const showWrongDateFormat = (
  date?: string,
  formatDate?: string,
  replaceSymbol?: string,
  isReplace?: boolean,
) => {
  if (!date || !date.length) return ''

  const rightDate = date.split('.').reverse().join('-')

  const result = dayjs(rightDate).format(
    formatDate || DATE_FORMAT_LIST.DATE_MONTH,
  )

  if (isReplace) {
    return result.replace(/\./g, replaceSymbol || '')
  }

  return result
}

export const prepareTimeShow = (common?: number) => {
  if (!common) {
    return 0
  }

  return {
    hours: Math.floor(common / 60),
    minutes: common % 60,
  }
}

export const addDate = ({ date, count, type }: AddDateManipulate): Date => {
  return dayjs(date || new Date())
    .add(count, type)
    .toDate()
}

export const differenceDate = ({
  dateStart,
  dateEnd,
  type,
  isFloat,
}: DateDifference): number => {
  return dayjs(dateEnd).diff(dateStart || new Date(), type, isFloat)
}

export const getEndDate = ({ date, type }: EndDate): Date => {
  return dayjs(date).endOf(type).toDate()
}

export const getAgeRange = (age: TYPE_AGE) => {
  const today = dayjs()
  const { minYears, maxYears } = ageRanges[age]

  const minDate = today.subtract(minYears, 'year').startOf('day')
  const maxDate = today.subtract(maxYears, 'year').endOf('day')

  return (date: Date | null) => {
    if (!date) return false
    const current = dayjs(date)
    return current.isAfter(minDate) && current.isBefore(maxDate)
  }
}

export const getIsBeforeDateAndSame = (
  currentDay?: string,
  nextDate?: string,
) => {
  return (
    dayjs(currentDay).isBefore(dayjs(nextDate)) ||
    dayjs(currentDay).isSame(dayjs(nextDate))
  )
}

export const isSearchDateActual = (dateStr?: string): boolean => {
  if (!dateStr || String(dateStr).length === 0) return false

  return !dayjs(dateStr).isBefore(dayjs(), 'day')
}
